<template>
  <div class="container">
    <p class="heading-secondary-main">
      Экономический обзор
    </p>
    <div class="reference__toggler">
      <div class="reference__toggler--inner">
        <div class="reference__dot" :style="{ left: toggleButtonPlace }"></div>
      </div>
      <div
        class="reference__toggler-item"
        :class="{ active: selectedGroupId === 4 }"
        @click="toggleButton(4)"
      >
        Отчетность
      </div>
      <div
        class="reference__toggler-item"
        :class="{ active: selectedGroupId === 5 }"
        @click="toggleButton(5)"
      >
        Дайджест
      </div>
    </div>
    <component :is="activeComponent" :reports="filteredReports"></component>
  </div>
</template>

<script>
import ReportList from "@/views/reviews/components/ReportList.vue";
import DigestList from "@/views/reviews/components/DigestList.vue";

import { actionTypes } from "@/store/modules/report";
import { mapState } from "vuex";
export default {
  components: {
    ReportList,
    DigestList,
  },
  data() {
    return {
      selectedGroupId: 4,
      filteredReports: null,
      activeComponent: "ReportList",
    };
  },
  computed: {
    ...mapState({
      isLoading: (state) => state.report.isLoading,
      reports: (state) => state.report.data,
      error: (state) => state.report.error,
    }),
    toggleButtonPlace() {
      return this.selectedGroupId === 4 ? "23%" : "73%";
    },
  },
  mounted() {
    this.getReportList();
  },
  methods: {
    getReportList() {
      this.$store.dispatch(actionTypes.getReportListAction).then(() => {
        this.getFilteredReport(this.selectedGroupId);
      });
    },
    goToReportDetail(id, selectedGroupId) {
      let chartName = selectedGroupId === 4 ? "chartReport" : "chartDigest";

      this.$router.push({
        name: chartName,
        params: {
          id,
        },
      });
    },
    toggleButton(value) {
      this.selectedGroupId = value;
      if (value == 4) {
        this.activeComponent = "ReportList";
      } else if (value == 5) {
        this.activeComponent = "DigestList";
      }
      this.getFilteredReport(value);
    },
    getFilteredReport(group_id) {
      this.filteredReports = this.reports.data.filter(
        (report) => report.group === group_id
      );
    },
    getSelectedReport() {
      return this.reports.data.filter(
        (report) => report.group === this.selectedGroupId
      );
    },
    getIcon(image_name) {
      return "/media/" + image_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.reference {
  background-color: #fff;
  max-width: 1110px;
  width: 100%;
  margin: auto;
  padding: 0 45px;
  &__toggler {
    max-width: 400px;
    width: 100%;
    border-radius: 30px 30px 30px 30px;
    border: 1px solid #0082be;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: inherit;
    margin-bottom: 6rem;
    &--inner {
      background: #ffffff;
      border: 1px solid #e9e9e9;
      width: 6rem;
      height: 3rem;
      box-shadow: 4px 4px 15px rgba(58, 117, 102, 0.2);
      border-radius: 10rem;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    &-item {
      width: 50%;
      font-size: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      text-align: center;
      color: #9c9898;
      padding: 1.5rem 4rem;
      cursor: pointer;
      height: 60px;
    }
  }
  &__dot {
    width: 2.2rem;
    height: 2.2rem;
    background: #0082be;
    border-radius: 10rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.line {
  &__list {
    margin-bottom: 10rem;
    margin-left: 3rem;
    display: block;
    & > li {
      margin-bottom: 20px;
      & > a {
        text-decoration: none;
        font-size: 1.4rem;
        color: #005177;
        transition: all 0.3s;
        border-bottom: 1px solid transparent;
        &:hover {
          border-bottom: 1px solid #005177;
        }
      }
    }
  }
}
.card {
  &__item {
    display: flex;
    flex-direction: column;
    background: #f4fbff;
    border: 1px dashed #46adf4;
    box-sizing: border-box;
    border-radius: 8px;
    width: 100%;
    height: 23.3rem;
    padding: 2rem 1.6rem;
    justify-content: space-between;
    transition: all 0.3s ease-in-out;
    cursor: pointer;
    &:hover {
      background: #0082be;
      border: 1px dashed #46adf4;
      border-radius: 0.8rem;
      & > .card {
        &__icon {
          filter: brightness(0) invert(1);
        }
        &__title {
          color: #ffffff;
        }
        &__text {
          color: #cce9ff;
        }
      }
      & > .button {
        background: #ffbe55;
        border: 1px solid #ffbe55;
        color: white;
      }
    }
  }
  &__list {
    margin-bottom: 10rem;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(256px, 1fr));
    grid-gap: 15px;
  }
  &__item {
    font-weight: 600;
    font-size: 1.4rem;
    text-align: center;
    letter-spacing: -0.02em;
    color: #005177;
  }
  &__text {
    font-size: 1.2rem;
    text-align: center;
    color: #9c9898;
  }
  &__icon {
    width: 3.8rem;
    height: 3.8rem;
    margin: 0 auto;
  }
}

.active {
  background: #0082be;
  color: white;
}
</style>
